module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-gynecological.4c3061a9.svg";